import * as types from './action-types';
import { getCollectionListener } from "../../firebase";

const collectionMap = {
	artists: getArtists,
	albums: getAlbums,
	features: getFeatures,
	genres: getGenres,
	labels: getLabels,
	featureCategories: setFeatureCategories
}

export function saveAlbum (album) {
	return { type: types.SAVE_ALBUM, album };
};

export function saveFeature (feature) {
	return { type: types.SAVE_FEATURE, feature };
};

export function getArtists (artists) {
	return { type: types.GET_ARTISTS, artists };
};

export function setAlbums (albums) {
	return { type: types.SET_ALBUMS, albums };
};

export function setAllAlbumsLoaded (allAlbumsLoaded) {
	return { type: types.SET_ALL_ALBUMS_LOADED, allAlbumsLoaded };
};

export function setAllFeaturesLoaded (allFeaturesLoaded) {
	return { type: types.SET_ALL_FEATURES_LOADED, allFeaturesLoaded };
};

export function setFeatureCategories (featureCategories) {
	return { type: types.SET_FEATURE_CATEGORIES, featureCategories }
}

export function appendAlbums (albums) {
	return { type: types.APPEND_ALBUMS, albums };
};

export function appendAllReviews (allReviews) {
	return { type: types.APPEND_ALL_REVIEWS, allReviews };
};

export function appendFeatures (features) {
	return { type: types.APPEND_FEATURES, features };
};

export function appendRecentReviews (recentReviews) {
	return { type: types.APPEND_RECENT_REVIEWS, recentReviews };
};

export function appendLegacyReviews (legacyReviews) {
	return { type: types.APPEND_LEGACY_REVIEWS, legacyReviews };
};

export function setAllReviews (allReviews) {
	return { type: types.SET_ALL_REVIEWS, allReviews };
};

export function setFeatures (features) {
	return { type: types.SET_FEATURES, features };
};

export function setLastAlbumDocument (lastAlbumDocument) {
	return { type: types.SET_LAST_ALBUM_DOCUMENT, lastAlbumDocument };
};

export function setLastFeatureDocument (lastFeatureDocument) {
	return { type: types.SET_LAST_FEATURE_DOCUMENT, lastFeatureDocument };
};

export function setLastReviewDocument (lastReviewDocument) {
	return { type: types.SET_LAST_REVIEW_DOCUMENT, lastReviewDocument };
};

export function setRecentReviews (recentReviews) {
	return { type: types.SET_RECENT_REVIEWS, recentReviews };
};

export function setLegacyReviews (legacyReviews) {
	return { type: types.SET_LEGACY_REVIEWS, legacyReviews };
};

export function getGenres (genres) {
	return { type: types.GET_GENRES, genres };
};

export function getLabels (labels) {
	return { type: types.GET_LABELS, labels };
};

export function getCollectionSubscription(collection, query) {
	return dispatch => {
		return getCollectionListener(collection, query, (items) => {
			dispatch(collectionMap[collection](items));
			return items;
		}, query);
	}
}
export function addNotification (notification) {
	return { type: types.ADD_NOTIFICATION, notification };
};

export function deleteNotification (notification) {
	return { type: types.DELETE_NOTIFICATION, notification };
};

export function getAlbums (albums) {
	return { type: types.GET_ALBUMS, albums };
};

export function getFeatures (features) {
	return { type: types.GET_FEATURES, features };
};

export function resetSelectedAlbum (selectedAlbum) {
	return { type: types.RESET_SELECTED_ALBUM };
};

export function resetSelectedArtist () {
	return { type: types.RESET_SELECTED_ARTIST };
};

export function resetSelectedFeature (selectedFeature) {
	return { type: types.RESET_SELECTED_FEATURE };
};

export function resetSelectedGenres (selectedGenres) {
	return { type: types.RESET_SELECTED_GENRES };
};

export function resetSelectedLabels (selectedLabels) {
	return { type: types.RESET_SELECTED_LABELS };
};

export function setImpersonationUser (impersonationUser) {
	return { type: types.SET_IMPERSONATION_USER, impersonationUser };
};

export function setIsAuthenticating (isAuthenticating) {
	return { type: types.SET_IS_AUTHENTICATING, isAuthenticating };
};

export function setIsFetchingFeatures (isFetchingFeatures) {
	return { type: types.SET_IS_FETCHING_FEATURES, isFetchingFeatures };
};

export function setIsFetchingRecentAlbums (isFetchingRecentAlbums) {
	return { type: types.SET_IS_FETCHING_RECENT_ALBUMS, isFetchingRecentAlbums };
};

export function setIsModalOpen (isModalOpen) {
	return { type: types.SET_IS_MODAL_OPEN, isModalOpen };
};

export function setSelectedAlbum (selectedAlbum) {
	return { type: types.SET_SELECTED_ALBUM, selectedAlbum };
};

export function setSelectedArtist (selectedArtist) {
	return { type: types.SET_SELECTED_ARTIST, selectedArtist };
};

export function setSelectedFeature (selectedFeature) {
	return { type: types.SET_SELECTED_FEATURE, selectedFeature };
};

export function setSelectedGenres (selectedGenres) {
	return { type: types.SET_SELECTED_GENRES, selectedGenres };
};

export function setSelectedLabels (selectedLabels) {
	return { type: types.SET_SELECTED_LABELS, selectedLabels };
};

export function setUsers (users) {
	return { type: types.SET_USERS, users };
};
